import axios from 'axios';
import qs from 'qs';
import { API_HOST_PROXY } from '@constants/api';
import { AuthorizationService } from '@services/auth';
import { handleServiceError } from '@utils';
import { Tenant } from '@utils/TenantContext';

const TENANT_KEY_PREFIX = 'tenant-';

export class TenantService extends AuthorizationService {
  static readonly serviceName: string = 'TenantService';

  public async getTenants(): Promise<Tenant[] | null> {
    try {
      const response = await axios.get(`${API_HOST_PROXY}/tenant`);

      return response.data;
    } catch (err) {
      handleServiceError(err);

      return null;
    }
  }

  public async createTenant(id: string, file: File): Promise<Tenant[] | false> {
    try {
      const formData = new FormData();
      formData.append('data', file);
      formData.append('key', process.env.TENANT_MANAGE_API_KEY);

      const response = await axios.post(`${API_HOST_PROXY}/tenant/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (err) {
      handleServiceError(err);

      return false;
    }
  }

  public async deleteTenant(key: string): Promise<Tenant[] | false> {
    try {
      const response = await axios.delete(`${API_HOST_PROXY}/tenant/${key.replace(TENANT_KEY_PREFIX, '')}`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({ key: process.env.TENANT_MANAGE_API_KEY })
      });

      return response.data;
    } catch (err) {
      handleServiceError(err);

      return false;
    }
  }
}
